'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const client = require('./client');

import Avatar from 'material-ui/Avatar';
import Container from 'muicss/lib/react/container';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';


export default class TableauEmbedded extends React.Component {
	
	constructor(props) {
		super(props);
	
		this.state = {
			dossierInstance:""
	    };
		var self = this;
		this.changeFilter = this.changeFilter.bind(this);
		this.checkLoad = this.checkLoad.bind(this);
		this.changeViz = this.changeViz.bind(this);
		this.exportPDF = this.exportPDF.bind(this);
		this.exportXLS = this.exportXLS.bind(this);
		this.viz = {};
		this.tableauOptions = {
				hideTabs: true,
				hideToolbar: true,
				onFirstInteractive: function() {
				}
		}
		this.currentFilter = "";
	}
	
	exportPDF(){
		this.viz.showExportPDFDialog();
	}
	
	exportXLS(){
		this.viz.showExportCrossTabDialog();
	}
	
	changeFilter(filterSelection){
		var self = this;
		var dashboard = this.viz.getWorkbook().getActiveSheet();
		var lStoreSelected = filterSelection.toString();
		var lAsyncCount = 0;
		if (filterSelection == 0){
			filterSelection = [1, 2, 3, 4];
		}
		
		/*
		dashboard.getWorksheets().forEach(function (sheet){
			sheet.getFiltersAsync().then(function(filters) {
				console.log("New sheet");
			    for (var x=0; x<filters.length; x++) {
			    	if(filters[x].getFieldName() == "Quarter"){
				        console.log(sheet.getName() +": "+filters[x].getFieldName());
				        console.log(sheet.getName() +": "+filters[x].getAppliedValues());
			    	}
			    }
			});
		});
		*/
		
		dashboard.getWorksheets().forEach(function (sheet){
			if (sheet._impl.$5 == "Map") {
				sheet.clearFilterAsync("Quarter")
				.then( function () {
					return sheet.clearSelectedMarksAsync();
				}, function (){
					return sheet.clearSelectedMarksAsync();
				})
				.then( function () {
					return sheet.getUnderlyingDataAsync();
				}, function (){
					return sheet.getUnderlyingDataAsync();
				})
				.then( function (data) {
					sheet.selectMarksAsync("Quarter", filterSelection, tableau.FilterUpdateType.REPLACE);
				});
			}else {
				lAsyncCount++;
				console.log("c:"+lAsyncCount);
				sheet.applyFilterAsync("Program", filterSelection, tableau.FilterUpdateType.REPLACE).then( function () {
					lAsyncCount--;
					console.log("c:"+lAsyncCount);
					if(lAsyncCount == 0){
						var el = document.getElementById('vizCourtain');
						el.style.display = "none";
						var el = document.getElementById('topCourtain');
						el.style.display = "none";
					}
				});				
			}
		});
		this.currentFilter = filterSelection;
	}
	
	changeViz(vizSelection) {
		var app =  this.props.app;
		var self = this;
		

		
		if(app.state.tableauToken !=""){
			if(vizSelection == "Sales Funnel") {
				var container = document.getElementById("vizContainer"),
				url ="https://tableau.xeomatrix.net/views/BrokerPortal-SalesFunnel/SalesFunnel?embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no";
				this.viz.dispose();
				this.viz.dispose();
				this.tableauOptions["Program"] = this.currentFilter;
				this.viz = new tableau.Viz(container, url, this.tableauOptions);
				this.tableauOptions.onFirstInteractive = {};
			} else if (vizSelection == "Location Performance"){
				var container = document.getElementById("vizContainer"),
				url ="https://tableau.xeomatrix.net/views/BrokerPortal-LocationPerformance/LocationPerformance?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no";
				this.viz.dispose();
				this.viz.dispose();
				this.tableauOptions["Program"] = this.currentFilter;
				this.viz = new tableau.Viz(container, url, this.tableauOptions);
			} else if (vizSelection == "Opportunity Detail") {
				var container = document.getElementById("vizContainer"),
				url ="https://tableau.xeomatrix.net/views/BrokerPortal-OpportunityDetail/OpportunityDetail?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no";
				this.viz.dispose();
				this.viz.dispose();
				this.tableauOptions["Program"] = this.currentFilter;
				this.viz = new tableau.Viz(container, url, this.tableauOptions);
			}
		}
	}
	
	componentDidUpdate() {

	}
	
	checkLoad(){
		if(this.viz.getInstanceId() != null){
			var app =  this.props.app,
			self = this,
			container = document.getElementById("vizContainer");
			var dashboard = self.viz.getWorkbook().getActiveSheet();
			var lStoreMap = {};
			//dashboard.getWorksheets().forEach(function (sheet){
				//self.props.app.mTableauNav.updateFilterElements(lStoreMap);
				//self.changeFilter("All");
				//	sheet.getFiltersAsync().then(function(filters) {
				//		console.log("New sheet");
				//	    for (var x=0; x<filters.length; x++) {
				//	    	if(filters[x].getFieldName() == "Quarter"){
				//		        console.log(sheet.getName() +": "+filters[x].getFieldName());
				//		        console.log(sheet.getName() +": "+filters[x].getAppliedValues());
				//	    	}
				//	    }
				//	});
			//});	
		}else{
			//setTimeout(this.checkLoad, 2000);
		}
	}
	
	componentDidMount() {
		var app =  this.props.app,
		self = this,
		container = document.getElementById("vizContainer"),
		url ="https://tableau.xeomatrix.net/trusted/"+app.state.tableauToken+"/views/BrokerPortal-SalesFunnel/SalesFunnel?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no";
		var x = 0;
		var postData = {};
		this.tableauOptions.onFirstInteractive = function(){

		};
		if(app.state.tableauToken !=""){
			this.tableauOptions["Program"] = "Home";
			this.viz = new tableau.Viz(container, url, this.tableauOptions);
		}
		this.tableauOptions.onFirstInteractive = {};
		//setTimeout(this.checkLoad, 2000);
	}
	
	render() {
		return (
				<div className="tableauEmbedded" style={{backgroundColor:"white", textAlign: "center", minHeight: "500px", height: "calc(100vh - 110px)"}} >
					<div id="topCourtain" style={{display: "none"}}/>
					<div id="vizCourtain" style={{display: "none"}}>
						<div className="loader"></div>
					</div>		
					<div id="vizContainer" style={{display: "", height: "100%"}}></div>			  
			  	</div>
			)
	}
}


// WEBPACK FOOTER //
// ./src/main/js/TableauEmbedded.js